import React, { useState } from "react";
import Dashboard from "../../components/Dashboard";
import Navbar from "../../components/Navbar";
import { useUser } from "../../context/user-context";
import { SlArrowRight } from "react-icons/sl";
import { moneySendd } from "../../assets/images";
import Pending from "../dashboardPage/sellCrypto/Pending";
import SellFromExAddy from "../dashboardPage/sellCrypto/SellFromExAddy";
import TransferFund from "../dashboardPage/sellCrypto/TransferFund";
import { RiExchangeBoxFill } from "react-icons/ri";
import { IoEyeSharp } from "react-icons/io5";
import { FaCreditCard } from "react-icons/fa";
import GifcardSent from "../dashboardPage/giftcards/GifcardSent";
import GiftcardPreview from "../dashboardPage/giftcards/GiftcardPreview";
import SelectCard from "../dashboardPage/giftcards/SelectCard";
import SelectCardValue from "../dashboardPage/giftcards/SelectCardValue";
import UploadGiftcard from "../dashboardPage/giftcards/UploadGiftcard";
import PreviewSwap from "../Wallet/PreviewSwap";
import SwapCoin from "../Wallet/SwapCoin";
import SwapSuccess from "../Wallet/SwapSuccess";
import CryptoRate from "./CryptoRate";
import GiftcardRate from "./GiftcardRate";

const Trade = () => {
  const { isOpen } = useUser();
  const [selectedCoinObj, setSelectedCoinObj] = useState<any>(null);
  const [selectedNetwork, setSelectedNetwork] = useState<string>("");
  const [openSellFromExAddy, setOpenSellFromExAddy] = useState<boolean>(false);

  const [openSellTransfer, setOpenSellTransfer] = useState<boolean>(false);
  const [openSellPending, setOpenSellPending] = useState<boolean>(false);
  //For Giftcards
  const [openSelectCard, setOpenSelectCard] = useState<boolean>(false);
  const [openSelectCardValue, setOpenSelectCardValue] =
    useState<boolean>(false);
  const [openGiftcardPreview, setOpenGiftcardPreview] =
    useState<boolean>(false);
  const [openGicardUpload, setOpenGicardUpload] = useState<boolean>(false);
  const [openGicardDone, setOpenGicardDone] = useState<boolean>(false);
  const [cardId, setCardId] = useState<string>("");
  const [cardName, setCardName] = useState<string>("");
  const [cardImg, setCardImg] = useState<string>("");
  const [card, setCard] = useState<any[]>([]);
  const [cardType, setCardType] = useState<string>("physical");
  const [receiptName, setReceiptName] = useState<string>("");

  const [denominationData, setDenominationData] = useState<any[]>([]);

  //swap
  const [openSwap, setOpenSwap] = useState<boolean>(false);

  const [openSwapPreview, setOpenSwapPreview] = useState<boolean>(false);

  const [openSwapSuccess, setOpenSwapSuccess] = useState<boolean>(false);

  const [selectedCoinToObj, setSelectedCoinToObj] = useState<any>(null);
  const [selectedCoinFromObj, setSelectedFromCoinObj] = useState<any>(null);
  const [recieveAmount, setReceiveAmount] = useState<string>("");
  const [feeAmount, setFeeAmount] = useState<string>("");
  const [orderID, setOrderID] = useState<string>("");
  const [swapAmount, setSwapAmount] = useState<string>("");
  //
  const [openCryptoRate, setOpenCryptoRate] = useState<boolean>(false);
  const [openGiftcardRate, setOpenGiftcardRate] = useState<boolean>(false);

  return (
    <div className="lgss:flex font-manrope  lgss:flex-row h-screen lgss:h-screen bg-[#E7EBEE]   dark:bg-[#13181B]">
      <Dashboard />
      <div
        className={
          isOpen
            ? "w-full h-full pt-0  font-manrope overflow-hidden lgss:px-0 flex flex-col justify-start item-start lgss:w-[80%]"
            : "w-full h-full pt-0  font-manrope overflow-auto lgss:px-0 flex flex-col justify-start item-start lgss:w-[80%]"
        }
      >
        <Navbar />
        <div className="w-full mt-10 pb-20 lgss:pb-8">
          <div className="w-full lgss:px-16 xxl:px-24 xxxl:px-36 md:px-12 mds:px-8 px-4 flex flex-col  ">
            <div className="w-full">
              <h4 className="font-sora text-left text-[16px] mt-8 font-semibold text-gray-900 dark:text-gray-200 ">
                Crypto
              </h4>
              <div className="w-ful mt-4">
                <div
                  onClick={() => setOpenSellFromExAddy(true)}
                  className="flex justify-between p-5 bg-white dark:bg-[#1C2227] rounded-xl   items-center cursor-pointer"
                >
                  <div className="flex justify-start items-center gap-4">
                    <div className="flex justify-center items-center  text-[20px] text-secondary_button w-[32px] h-[32px] rounded-full">
                      <div className="w-[24px] h-[24px]">
                        <img
                          src={moneySendd}
                          className="w-full h-full bg-cover"
                          alt=""
                        />
                      </div>{" "}
                    </div>
                    <div>
                      <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
                        Sell Crypto
                      </h4>
                      <h4 className="text-gray-500  mt-1  text-[13px] ">
                        Sell crypto for cash
                      </h4>
                    </div>
                  </div>
                  <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
                </div>
              </div>
              <div className="w-ful mt-4">
                <div
                  onClick={() => setOpenSwap(true)}
                  className="flex justify-between p-5 bg-white dark:bg-[#1C2227] rounded-xl   items-center cursor-pointer"
                >
                  <div className="flex justify-start items-center gap-4">
                    <div className="flex justify-center items-center  text-[20px] text-secondary_button w-[32px] h-[32px] rounded-full">
                      <RiExchangeBoxFill />
                    </div>
                    <div>
                      <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
                        Swap
                      </h4>
                      <h4 className="text-gray-500 mt-1  text-[13px] ">
                        Swap one cryptocurrency for another
                      </h4>
                    </div>
                  </div>
                  <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
                </div>
                <div className="w-ful mt-4">
                  <div
                    onClick={() => setOpenCryptoRate(true)}
                    className="flex justify-between p-5 bg-white dark:bg-[#1C2227] rounded-xl   items-center cursor-pointer"
                  >
                    <div className="flex justify-start items-center gap-4">
                      <div className="flex justify-center items-center  text-[24px] text-secondary_button w-[32px] h-[32px] rounded-full">
                        <IoEyeSharp />
                      </div>
                      <div>
                        <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
                          See rates
                        </h4>
                        <h4 className="text-gray-500 mt-1  text-[13px] ">
                          Look up crypto rates
                        </h4>
                      </div>
                    </div>
                    <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full">
              <h4 className="font-sora text-left text-[16px] mt-8 font-semibold text-gray-900 dark:text-gray-200 ">
                Giftcard
              </h4>
              <div className="w-ful mt-4">
                <div
                  onClick={() => setOpenSelectCard(true)}
                  className="flex justify-between p-5 bg-white dark:bg-[#1C2227] rounded-xl   items-center cursor-pointer"
                >
                  <div className="flex justify-start items-center gap-4">
                    <div className="flex justify-center items-center  text-[24px] text-secondary_button w-[32px] h-[32px] rounded-full">
                      <FaCreditCard />
                    </div>
                    <div>
                      <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
                        Sell Gift cards
                      </h4>
                      <h4 className="text-gray-500 mt-1  text-[13px] ">
                        Exchange your gift cards for Naira
                      </h4>
                    </div>
                  </div>
                  <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
                </div>
              </div>
              <div className="w-ful mt-4">
                <div
                  onClick={() => setOpenGiftcardRate(true)}
                  className="flex justify-between p-5 bg-white dark:bg-[#1C2227] rounded-xl   items-center cursor-pointer"
                >
                  <div className="flex justify-start items-center gap-4">
                    <div className="flex justify-center items-center  text-[24px] text-secondary_button w-[32px] h-[32px] rounded-full">
                      <IoEyeSharp />
                    </div>
                    <div>
                      <h4 className="text-[#13181B] dark:text-gray-300 font-medium text-[15px] ">
                        See rates
                      </h4>
                      <h4 className="text-gray-500 mt-1  text-[13px] ">
                        Look up card rates
                      </h4>
                    </div>
                  </div>
                  <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {openSellFromExAddy && (
          <SellFromExAddy
            setOpenSellFromExAddy={setOpenSellFromExAddy}
            // setOpenSellFrom={setOpenSellFrom}
            setOpenSellTransfer={setOpenSellTransfer}
            selectedCoinObj={selectedCoinObj}
            setSelectedCoinObj={setSelectedCoinObj}
            selectedNetwork={selectedNetwork}
            setSelectedNetwork={setSelectedNetwork}
          />
        )}
        {openSellTransfer && (
          <TransferFund
            setOpenSellPending={setOpenSellPending}
            setOpenSellTransfer={setOpenSellTransfer}
            setOpenSellFromExAddy={setOpenSellFromExAddy}
            selectedNetwork={selectedNetwork}
            selectedCoinObj={selectedCoinObj}
            setSelectedNetwork={setSelectedNetwork}
          />
        )}
        {openSellPending && (
          <Pending
            setOpenSellPending={setOpenSellPending}
            // setOpenSellFrom={setOpenSellFrom}
          />
        )}
        {openSelectCard && (
          <SelectCard
            setOpenSelectCard={setOpenSelectCard}
            setOpenSelectCardValue={setOpenSelectCardValue}
            setCardId={setCardId}
            cardId={cardId}
            cardName={cardName}
            setCardName={setCardName}
            cardImg={cardImg}
            setCardImg={setCardImg}
            setCard={setCard}
            cardType={cardType}
            setCardType={setCardType}
            receiptName={receiptName}
            setReceiptName={setReceiptName}
          />
        )}
        {openSelectCardValue && (
          <SelectCardValue
            setOpenSelectCard={setOpenSelectCard}
            setOpenSelectCardValue={setOpenSelectCardValue}
            setOpenGiftcardPreview={setOpenGiftcardPreview}
            cardName={cardName}
            cardImg={cardImg}
            card={card}
            setDenominationData={setDenominationData}
            denominationData={denominationData}
          />
        )}
        {openGiftcardPreview && (
          <GiftcardPreview
            setOpenGicardUpload={setOpenGicardUpload}
            setOpenSelectCardValue={setOpenSelectCardValue}
            setOpenGiftcardPreview={setOpenGiftcardPreview}
            cardName={cardName}
            denominationData={denominationData}
          />
        )}
        {openGicardUpload && (
          <UploadGiftcard
            setOpenGicardUpload={setOpenGicardUpload}
            setOpenGiftcardPreview={setOpenGiftcardPreview}
            setOpenGicardDone={setOpenGicardDone}
            cardType={cardType}
            cardName={cardName}
            cardId={cardId}
            receiptName={receiptName}
            denominationData={denominationData}
          />
        )}
        {openGicardDone && (
          <GifcardSent
            setOpenGicardDone={setOpenGicardDone}
            setDenominationData={setDenominationData}
          />
        )}

        {openSwap && (
          <SwapCoin
            setOpenSwap={setOpenSwap}
            setOpenSwapPreview={setOpenSwapPreview}
            selectedCoinObjj={selectedCoinObj}
            selectedCoinToObj={selectedCoinToObj}
            setSelectedCoinToObj={setSelectedCoinToObj}
            selectedCoinFromObj={selectedCoinFromObj}
            setSelectedFromCoinObj={setSelectedFromCoinObj}
            recieveAmount={recieveAmount}
            setReceiveAmount={setReceiveAmount}
            setFeeAmount={setFeeAmount}
            setOrderID={setOrderID}
            amount={swapAmount}
            setAmount={setSwapAmount}
          />
        )}
        {openSwapPreview && (
          <PreviewSwap
            setOpenSwap={setOpenSwap}
            setOpenSwapPreview={setOpenSwapPreview}
            setOpenSwapSuccess={setOpenSwapSuccess}
            selectedCoinToObj={selectedCoinToObj}
            selectedCoinFromObj={selectedCoinFromObj}
            feeAmount={feeAmount}
            recieveAmount={recieveAmount}
            orderID={orderID}
            setOrderID={setOrderID}
            amount={swapAmount}
            setReceiveAmount={setReceiveAmount}
            setFeeAmount={setFeeAmount}
          />
        )}
        {openSwapSuccess && (
          <SwapSuccess
            setOpenSwapPreview={setOpenSwapPreview}
            setOpenSwapSuccess={setOpenSwapSuccess}
            setOpenSwap={setOpenSwap}
          />
        )}
        {openCryptoRate && <CryptoRate setOpenCryptoRate={setOpenCryptoRate} />}
        {openGiftcardRate && (
          <GiftcardRate setOpenGiftcardRate={setOpenGiftcardRate} />
        )}
      </div>
    </div>
  );
};

export default Trade;
